<template>
    <div
        :class="['square', { selected: isSelected}]"
        :style="{ backgroundColor: isSelected ? selectedColor : color }"
        @click="toggleSelect">
        <span v-if="isSelected" class="checkmark"></span>
    </div>
</template>

<script>
export default {
    props: {
        id: {
            type: [String, Number],
            required: true,
        },
        value: {
            type: [String, Number],
            required: true,
        },
        color: {
            type: String,
            default: '#ccc',
        },
        selectedColor: {
            type: String,
            default: '#4caf50' // green
        },
        selectedItems: {
            type: Array,
            default: () => []
        },
    },
    computed: {
        isSelected() {
            return this.selectedItems.some(item => item.id === this.id);
        }
    },
    methods: {
        toggleSelect() {
            this.$emit('toggle', this.id, this.value);
        }
    }
}
</script>

<style scoped>
.square {
  width: 16px;
  height: 12px;
  border: 1px solid #D7D3BF;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
  user-select: none;
  margin: 3px;
  border-radius: 3px;
  transition: background-color 0.3s ease, border-color 0.3s ease;
}
.square.selected {
  border-color: #4caf50;
}
.checkmark {
  font-size: 2rem;
  color: white;
}
</style>